import React from "react";
import { Spinner } from "components/common";
import CounterRate from "../../metrics/CounterRate";
import useForwarderInputState from "../../hooks/useForwarderInputState";
const TrafficLastMinuteCell = ({ forwarderId, inputId }) => {
  var _a;
  const { data, isPending } = useForwarderInputState(forwarderId != null ? forwarderId : "", inputId);
  const incomingMessagesMetric = (_a = data == null ? void 0 : data.metrics) == null ? void 0 : _a.find((m) => m.name === "incomingMessages");
  if (!forwarderId) {
    return /* @__PURE__ */ React.createElement("em", null, "N/A");
  }
  if (isPending) {
    return /* @__PURE__ */ React.createElement(Spinner, { size: "xs" });
  }
  if (!incomingMessagesMetric) {
    return /* @__PURE__ */ React.createElement("span", null, "Not available");
  }
  return /* @__PURE__ */ React.createElement(CounterRate, { metric: incomingMessagesMetric, suffix: "msg/s" });
};
export default TrafficLastMinuteCell;
